// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/documents_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Attachment } from "./common_pb.ts";
import { Document, DocumentScope, DocumentStatus, DocumentType } from "./documents_pb.ts";
import { ContentUpdates } from "./notes_pb.ts";
import { EmailMessage } from "./conversation_pb.ts";

/**
 * @generated from message protogen.CreateDocumentRequest
 */
export class CreateDocumentRequest extends Message<CreateDocumentRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  /**
   * @generated from field: string textContent = 4;
   */
  textContent = "";

  /**
   * @generated from field: repeated protogen.Attachment attachments = 5;
   */
  attachments: Attachment[] = [];

  /**
   * @generated from field: protogen.DocumentType documentType = 6;
   */
  documentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: repeated string topics = 7;
   */
  topics: string[] = [];

  constructor(data?: PartialMessage<CreateDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "textContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "attachments", kind: "message", T: Attachment, repeated: true },
    { no: 6, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 7, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDocumentRequest {
    return new CreateDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDocumentRequest {
    return new CreateDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDocumentRequest {
    return new CreateDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDocumentRequest | PlainMessage<CreateDocumentRequest> | undefined, b: CreateDocumentRequest | PlainMessage<CreateDocumentRequest> | undefined): boolean {
    return proto3.util.equals(CreateDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateDocumentResponse
 */
export class CreateDocumentResponse extends Message<CreateDocumentResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<CreateDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDocumentResponse {
    return new CreateDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDocumentResponse {
    return new CreateDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDocumentResponse {
    return new CreateDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDocumentResponse | PlainMessage<CreateDocumentResponse> | undefined, b: CreateDocumentResponse | PlainMessage<CreateDocumentResponse> | undefined): boolean {
    return proto3.util.equals(CreateDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateMemberDocumentRequest
 */
export class CreateMemberDocumentRequest extends Message<CreateMemberDocumentRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  /**
   * @generated from field: string textContent = 3;
   */
  textContent = "";

  /**
   * @generated from field: repeated protogen.Attachment attachments = 4;
   */
  attachments: Attachment[] = [];

  /**
   * @generated from field: protogen.DocumentType documentType = 5;
   */
  documentType = DocumentType.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateMemberDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateMemberDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "textContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attachments", kind: "message", T: Attachment, repeated: true },
    { no: 5, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMemberDocumentRequest {
    return new CreateMemberDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMemberDocumentRequest {
    return new CreateMemberDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMemberDocumentRequest {
    return new CreateMemberDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMemberDocumentRequest | PlainMessage<CreateMemberDocumentRequest> | undefined, b: CreateMemberDocumentRequest | PlainMessage<CreateMemberDocumentRequest> | undefined): boolean {
    return proto3.util.equals(CreateMemberDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateMemberDocumentResponse
 */
export class CreateMemberDocumentResponse extends Message<CreateMemberDocumentResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<CreateMemberDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateMemberDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMemberDocumentResponse {
    return new CreateMemberDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMemberDocumentResponse {
    return new CreateMemberDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMemberDocumentResponse {
    return new CreateMemberDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMemberDocumentResponse | PlainMessage<CreateMemberDocumentResponse> | undefined, b: CreateMemberDocumentResponse | PlainMessage<CreateMemberDocumentResponse> | undefined): boolean {
    return proto3.util.equals(CreateMemberDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetDocumentRequest
 */
export class GetDocumentRequest extends Message<GetDocumentRequest> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: protogen.DocumentType documentType = 2;
   */
  documentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: bool isFormDefinition = 3;
   */
  isFormDefinition = false;

  /**
   * @generated from field: bool markAsRead = 4;
   */
  markAsRead = false;

  constructor(data?: PartialMessage<GetDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 3, name: "isFormDefinition", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "markAsRead", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDocumentRequest {
    return new GetDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDocumentRequest {
    return new GetDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDocumentRequest {
    return new GetDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDocumentRequest | PlainMessage<GetDocumentRequest> | undefined, b: GetDocumentRequest | PlainMessage<GetDocumentRequest> | undefined): boolean {
    return proto3.util.equals(GetDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetDocumentResponse
 */
export class GetDocumentResponse extends Message<GetDocumentResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<GetDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDocumentResponse {
    return new GetDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDocumentResponse {
    return new GetDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDocumentResponse {
    return new GetDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDocumentResponse | PlainMessage<GetDocumentResponse> | undefined, b: GetDocumentResponse | PlainMessage<GetDocumentResponse> | undefined): boolean {
    return proto3.util.equals(GetDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDocumentRequest
 */
export class UpdateDocumentRequest extends Message<UpdateDocumentRequest> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: protogen.ContentUpdates content = 3;
   */
  content?: ContentUpdates;

  /**
   * @generated from field: string prevHash = 4;
   */
  prevHash = "";

  /**
   * @generated from field: bool shouldUpdateTitle = 5;
   */
  shouldUpdateTitle = false;

  /**
   * @generated from field: bool shouldUpdateContent = 6;
   */
  shouldUpdateContent = false;

  /**
   * @generated from field: protogen.DocumentScope scope = 7;
   */
  scope = DocumentScope.UNSPECIFIED;

  /**
   * @generated from field: protogen.DocumentStatus status = 8;
   */
  status = DocumentStatus.UNSPECIFIED;

  /**
   * @generated from field: protogen.DocumentType documentType = 9;
   */
  documentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string updatedFormInstanceScope = 10;
   */
  updatedFormInstanceScope = "";

  /**
   * @generated from field: repeated string updatedFormNotifications = 11;
   */
  updatedFormNotifications: string[] = [];

  /**
   * @generated from field: bool shouldUpdateTopics = 12;
   */
  shouldUpdateTopics = false;

  /**
   * @generated from field: repeated string updatedTopics = 13;
   */
  updatedTopics: string[] = [];

  /**
   * @generated from field: bool shouldUpdateFormNotifications = 14;
   */
  shouldUpdateFormNotifications = false;

  /**
   * @generated from field: bool updatedFormMultiInstance = 15;
   */
  updatedFormMultiInstance = false;

  /**
   * @generated from field: bool shouldUpdateFormMultiInstance = 16;
   */
  shouldUpdateFormMultiInstance = false;

  constructor(data?: PartialMessage<UpdateDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "message", T: ContentUpdates },
    { no: 4, name: "prevHash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "shouldUpdateTitle", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "shouldUpdateContent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "scope", kind: "enum", T: proto3.getEnumType(DocumentScope) },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(DocumentStatus) },
    { no: 9, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 10, name: "updatedFormInstanceScope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "updatedFormNotifications", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "shouldUpdateTopics", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "updatedTopics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "shouldUpdateFormNotifications", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "updatedFormMultiInstance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "shouldUpdateFormMultiInstance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDocumentRequest {
    return new UpdateDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDocumentRequest {
    return new UpdateDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDocumentRequest {
    return new UpdateDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDocumentRequest | PlainMessage<UpdateDocumentRequest> | undefined, b: UpdateDocumentRequest | PlainMessage<UpdateDocumentRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDocumentResponse
 */
export class UpdateDocumentResponse extends Message<UpdateDocumentResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<UpdateDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDocumentResponse {
    return new UpdateDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDocumentResponse {
    return new UpdateDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDocumentResponse {
    return new UpdateDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDocumentResponse | PlainMessage<UpdateDocumentResponse> | undefined, b: UpdateDocumentResponse | PlainMessage<UpdateDocumentResponse> | undefined): boolean {
    return proto3.util.equals(UpdateDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListDocumentsRequest
 */
export class ListDocumentsRequest extends Message<ListDocumentsRequest> {
  /**
   * @generated from field: repeated string familyRefs = 1;
   */
  familyRefs: string[] = [];

  /**
   * @generated from field: repeated protogen.DocumentType documentTypes = 2;
   */
  documentTypes: DocumentType[] = [];

  /**
   * @generated from field: bool includeAdvisorDocuments = 3;
   */
  includeAdvisorDocuments = false;

  /**
   * @generated from field: bool favoritesOnly = 4;
   */
  favoritesOnly = false;

  /**
   * @generated from field: bool includeEmptyDocuments = 5;
   */
  includeEmptyDocuments = false;

  /**
   * @generated from field: bool includeCommunitySharedDocuments = 6;
   */
  includeCommunitySharedDocuments = false;

  /**
   * @generated from field: repeated string anyTopics = 7;
   */
  anyTopics: string[] = [];

  /**
   * @generated from field: bool includeAllFavorites = 8;
   */
  includeAllFavorites = false;

  /**
   * @generated from field: bool includeFamilyBotDocuments = 9;
   */
  includeFamilyBotDocuments = false;

  constructor(data?: PartialMessage<ListDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "documentTypes", kind: "enum", T: proto3.getEnumType(DocumentType), repeated: true },
    { no: 3, name: "includeAdvisorDocuments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "favoritesOnly", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "includeEmptyDocuments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "includeCommunitySharedDocuments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "anyTopics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "includeAllFavorites", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "includeFamilyBotDocuments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentsRequest {
    return new ListDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentsRequest {
    return new ListDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentsRequest {
    return new ListDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentsRequest | PlainMessage<ListDocumentsRequest> | undefined, b: ListDocumentsRequest | PlainMessage<ListDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(ListDocumentsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListDocumentsResponse
 */
export class ListDocumentsResponse extends Message<ListDocumentsResponse> {
  /**
   * @generated from field: repeated protogen.Document documents = 1;
   */
  documents: Document[] = [];

  constructor(data?: PartialMessage<ListDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: Document, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentsResponse {
    return new ListDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentsResponse {
    return new ListDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentsResponse {
    return new ListDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentsResponse | PlainMessage<ListDocumentsResponse> | undefined, b: ListDocumentsResponse | PlainMessage<ListDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(ListDocumentsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListMemberDocumentsRequest
 */
export class ListMemberDocumentsRequest extends Message<ListMemberDocumentsRequest> {
  /**
   * @generated from field: repeated protogen.DocumentType documentTypes = 1;
   */
  documentTypes: DocumentType[] = [];

  /**
   * @generated from field: bool includeAdvisorDocuments = 2;
   */
  includeAdvisorDocuments = false;

  /**
   * @generated from field: bool favoritesOnly = 3;
   */
  favoritesOnly = false;

  /**
   * @generated from field: bool includeEmptyDocuments = 4;
   */
  includeEmptyDocuments = false;

  /**
   * @generated from field: repeated string anyTopics = 5;
   */
  anyTopics: string[] = [];

  constructor(data?: PartialMessage<ListMemberDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListMemberDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentTypes", kind: "enum", T: proto3.getEnumType(DocumentType), repeated: true },
    { no: 2, name: "includeAdvisorDocuments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "favoritesOnly", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "includeEmptyDocuments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "anyTopics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMemberDocumentsRequest {
    return new ListMemberDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMemberDocumentsRequest {
    return new ListMemberDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMemberDocumentsRequest {
    return new ListMemberDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMemberDocumentsRequest | PlainMessage<ListMemberDocumentsRequest> | undefined, b: ListMemberDocumentsRequest | PlainMessage<ListMemberDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(ListMemberDocumentsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListMemberDocumentsResponse
 */
export class ListMemberDocumentsResponse extends Message<ListMemberDocumentsResponse> {
  /**
   * @generated from field: repeated protogen.Document documents = 1;
   */
  documents: Document[] = [];

  constructor(data?: PartialMessage<ListMemberDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListMemberDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: Document, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMemberDocumentsResponse {
    return new ListMemberDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMemberDocumentsResponse {
    return new ListMemberDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMemberDocumentsResponse {
    return new ListMemberDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMemberDocumentsResponse | PlainMessage<ListMemberDocumentsResponse> | undefined, b: ListMemberDocumentsResponse | PlainMessage<ListMemberDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(ListMemberDocumentsResponse, a, b);
  }
}

/**
 * @generated from message protogen.CopyDocumentRequest
 */
export class CopyDocumentRequest extends Message<CopyDocumentRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: protogen.DocumentType fromDocumentType = 2;
   */
  fromDocumentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string fromEntityType = 3;
   */
  fromEntityType = "";

  /**
   * @generated from field: string fromEntityRef = 4;
   */
  fromEntityRef = "";

  /**
   * @generated from field: protogen.DocumentType toDocumentType = 5;
   */
  toDocumentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string toEntityType = 6;
   */
  toEntityType = "";

  /**
   * @generated from field: string toEntityRef = 7;
   */
  toEntityRef = "";

  /**
   * @generated from field: string title = 8;
   */
  title = "";

  /**
   * @generated from field: bool replaceTitle = 9;
   */
  replaceTitle = false;

  /**
   * @generated from field: bool shouldClearOriginalContent = 10;
   */
  shouldClearOriginalContent = false;

  /**
   * @generated from field: string creationSourceName = 11;
   */
  creationSourceName = "";

  constructor(data?: PartialMessage<CopyDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CopyDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fromDocumentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 3, name: "fromEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fromEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "toDocumentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 6, name: "toEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "toEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "replaceTitle", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "shouldClearOriginalContent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "creationSourceName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CopyDocumentRequest {
    return new CopyDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CopyDocumentRequest {
    return new CopyDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CopyDocumentRequest {
    return new CopyDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CopyDocumentRequest | PlainMessage<CopyDocumentRequest> | undefined, b: CopyDocumentRequest | PlainMessage<CopyDocumentRequest> | undefined): boolean {
    return proto3.util.equals(CopyDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.CopyDocumentResponse
 */
export class CopyDocumentResponse extends Message<CopyDocumentResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<CopyDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CopyDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CopyDocumentResponse {
    return new CopyDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CopyDocumentResponse {
    return new CopyDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CopyDocumentResponse {
    return new CopyDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CopyDocumentResponse | PlainMessage<CopyDocumentResponse> | undefined, b: CopyDocumentResponse | PlainMessage<CopyDocumentResponse> | undefined): boolean {
    return proto3.util.equals(CopyDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.CopyMemberDocumentRequest
 */
export class CopyMemberDocumentRequest extends Message<CopyMemberDocumentRequest> {
  /**
   * @generated from field: protogen.DocumentType fromDocumentType = 1;
   */
  fromDocumentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string fromEntityType = 2;
   */
  fromEntityType = "";

  /**
   * @generated from field: string fromEntityRef = 3;
   */
  fromEntityRef = "";

  /**
   * @generated from field: string title = 4;
   */
  title = "";

  /**
   * @generated from field: bool replaceTitle = 5;
   */
  replaceTitle = false;

  /**
   * @generated from field: string creationSourceName = 6;
   */
  creationSourceName = "";

  constructor(data?: PartialMessage<CopyMemberDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CopyMemberDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fromDocumentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 2, name: "fromEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fromEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "replaceTitle", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "creationSourceName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CopyMemberDocumentRequest {
    return new CopyMemberDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CopyMemberDocumentRequest {
    return new CopyMemberDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CopyMemberDocumentRequest {
    return new CopyMemberDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CopyMemberDocumentRequest | PlainMessage<CopyMemberDocumentRequest> | undefined, b: CopyMemberDocumentRequest | PlainMessage<CopyMemberDocumentRequest> | undefined): boolean {
    return proto3.util.equals(CopyMemberDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.CopyMemberDocumentResponse
 */
export class CopyMemberDocumentResponse extends Message<CopyMemberDocumentResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<CopyMemberDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CopyMemberDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CopyMemberDocumentResponse {
    return new CopyMemberDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CopyMemberDocumentResponse {
    return new CopyMemberDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CopyMemberDocumentResponse {
    return new CopyMemberDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CopyMemberDocumentResponse | PlainMessage<CopyMemberDocumentResponse> | undefined, b: CopyMemberDocumentResponse | PlainMessage<CopyMemberDocumentResponse> | undefined): boolean {
    return proto3.util.equals(CopyMemberDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateEmailDraftFromDocumentRequest
 */
export class CreateEmailDraftFromDocumentRequest extends Message<CreateEmailDraftFromDocumentRequest> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: string familyRef = 2;
   */
  familyRef = "";

  constructor(data?: PartialMessage<CreateEmailDraftFromDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateEmailDraftFromDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateEmailDraftFromDocumentRequest {
    return new CreateEmailDraftFromDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateEmailDraftFromDocumentRequest {
    return new CreateEmailDraftFromDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateEmailDraftFromDocumentRequest {
    return new CreateEmailDraftFromDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateEmailDraftFromDocumentRequest | PlainMessage<CreateEmailDraftFromDocumentRequest> | undefined, b: CreateEmailDraftFromDocumentRequest | PlainMessage<CreateEmailDraftFromDocumentRequest> | undefined): boolean {
    return proto3.util.equals(CreateEmailDraftFromDocumentRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateEmailDraftFromDocumentResponse
 */
export class CreateEmailDraftFromDocumentResponse extends Message<CreateEmailDraftFromDocumentResponse> {
  /**
   * @generated from field: string draftRef = 2;
   */
  draftRef = "";

  /**
   * @generated from field: protogen.EmailMessage email = 3;
   */
  email?: EmailMessage;

  constructor(data?: PartialMessage<CreateEmailDraftFromDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateEmailDraftFromDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "draftRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "message", T: EmailMessage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateEmailDraftFromDocumentResponse {
    return new CreateEmailDraftFromDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateEmailDraftFromDocumentResponse {
    return new CreateEmailDraftFromDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateEmailDraftFromDocumentResponse {
    return new CreateEmailDraftFromDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateEmailDraftFromDocumentResponse | PlainMessage<CreateEmailDraftFromDocumentResponse> | undefined, b: CreateEmailDraftFromDocumentResponse | PlainMessage<CreateEmailDraftFromDocumentResponse> | undefined): boolean {
    return proto3.util.equals(CreateEmailDraftFromDocumentResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListFeaturedDocumentsRequest
 */
export class ListFeaturedDocumentsRequest extends Message<ListFeaturedDocumentsRequest> {
  /**
   * @generated from field: repeated string anyTopics = 1;
   */
  anyTopics: string[] = [];

  /**
   * @generated from field: bool favoritesOnly = 2;
   */
  favoritesOnly = false;

  constructor(data?: PartialMessage<ListFeaturedDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFeaturedDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "anyTopics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "favoritesOnly", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFeaturedDocumentsRequest {
    return new ListFeaturedDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFeaturedDocumentsRequest {
    return new ListFeaturedDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFeaturedDocumentsRequest {
    return new ListFeaturedDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFeaturedDocumentsRequest | PlainMessage<ListFeaturedDocumentsRequest> | undefined, b: ListFeaturedDocumentsRequest | PlainMessage<ListFeaturedDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(ListFeaturedDocumentsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListFeaturedDocumentsResponse
 */
export class ListFeaturedDocumentsResponse extends Message<ListFeaturedDocumentsResponse> {
  /**
   * @generated from field: repeated protogen.ListFeaturedDocumentsResponse.FeaturedDocument featuredDocuments = 1;
   */
  featuredDocuments: ListFeaturedDocumentsResponse_FeaturedDocument[] = [];

  constructor(data?: PartialMessage<ListFeaturedDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFeaturedDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "featuredDocuments", kind: "message", T: ListFeaturedDocumentsResponse_FeaturedDocument, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFeaturedDocumentsResponse {
    return new ListFeaturedDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFeaturedDocumentsResponse {
    return new ListFeaturedDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFeaturedDocumentsResponse {
    return new ListFeaturedDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFeaturedDocumentsResponse | PlainMessage<ListFeaturedDocumentsResponse> | undefined, b: ListFeaturedDocumentsResponse | PlainMessage<ListFeaturedDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(ListFeaturedDocumentsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListFeaturedDocumentsResponse.FeaturedDocument
 */
export class ListFeaturedDocumentsResponse_FeaturedDocument extends Message<ListFeaturedDocumentsResponse_FeaturedDocument> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  constructor(data?: PartialMessage<ListFeaturedDocumentsResponse_FeaturedDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFeaturedDocumentsResponse.FeaturedDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFeaturedDocumentsResponse_FeaturedDocument {
    return new ListFeaturedDocumentsResponse_FeaturedDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFeaturedDocumentsResponse_FeaturedDocument {
    return new ListFeaturedDocumentsResponse_FeaturedDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFeaturedDocumentsResponse_FeaturedDocument {
    return new ListFeaturedDocumentsResponse_FeaturedDocument().fromJsonString(jsonString, options);
  }

  static equals(a: ListFeaturedDocumentsResponse_FeaturedDocument | PlainMessage<ListFeaturedDocumentsResponse_FeaturedDocument> | undefined, b: ListFeaturedDocumentsResponse_FeaturedDocument | PlainMessage<ListFeaturedDocumentsResponse_FeaturedDocument> | undefined): boolean {
    return proto3.util.equals(ListFeaturedDocumentsResponse_FeaturedDocument, a, b);
  }
}

/**
 * @generated from message protogen.ToggleDocumentFavoriteRequest
 */
export class ToggleDocumentFavoriteRequest extends Message<ToggleDocumentFavoriteRequest> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: protogen.DocumentType documentType = 2;
   */
  documentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string entityType = 3;
   */
  entityType = "";

  /**
   * @generated from field: bool isFavorite = 4;
   */
  isFavorite = false;

  constructor(data?: PartialMessage<ToggleDocumentFavoriteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ToggleDocumentFavoriteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 3, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "isFavorite", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ToggleDocumentFavoriteRequest {
    return new ToggleDocumentFavoriteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ToggleDocumentFavoriteRequest {
    return new ToggleDocumentFavoriteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ToggleDocumentFavoriteRequest {
    return new ToggleDocumentFavoriteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ToggleDocumentFavoriteRequest | PlainMessage<ToggleDocumentFavoriteRequest> | undefined, b: ToggleDocumentFavoriteRequest | PlainMessage<ToggleDocumentFavoriteRequest> | undefined): boolean {
    return proto3.util.equals(ToggleDocumentFavoriteRequest, a, b);
  }
}

/**
 * @generated from message protogen.ToggleDocumentFavoriteResponse
 */
export class ToggleDocumentFavoriteResponse extends Message<ToggleDocumentFavoriteResponse> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: protogen.DocumentType documentType = 2;
   */
  documentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string entityType = 3;
   */
  entityType = "";

  /**
   * @generated from field: bool isFavorite = 4;
   */
  isFavorite = false;

  constructor(data?: PartialMessage<ToggleDocumentFavoriteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ToggleDocumentFavoriteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 3, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "isFavorite", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ToggleDocumentFavoriteResponse {
    return new ToggleDocumentFavoriteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ToggleDocumentFavoriteResponse {
    return new ToggleDocumentFavoriteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ToggleDocumentFavoriteResponse {
    return new ToggleDocumentFavoriteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ToggleDocumentFavoriteResponse | PlainMessage<ToggleDocumentFavoriteResponse> | undefined, b: ToggleDocumentFavoriteResponse | PlainMessage<ToggleDocumentFavoriteResponse> | undefined): boolean {
    return proto3.util.equals(ToggleDocumentFavoriteResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListDocumentTopicsRequest
 */
export class ListDocumentTopicsRequest extends Message<ListDocumentTopicsRequest> {
  constructor(data?: PartialMessage<ListDocumentTopicsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDocumentTopicsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentTopicsRequest {
    return new ListDocumentTopicsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentTopicsRequest {
    return new ListDocumentTopicsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentTopicsRequest {
    return new ListDocumentTopicsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentTopicsRequest | PlainMessage<ListDocumentTopicsRequest> | undefined, b: ListDocumentTopicsRequest | PlainMessage<ListDocumentTopicsRequest> | undefined): boolean {
    return proto3.util.equals(ListDocumentTopicsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListDocumentTopicsResponse
 */
export class ListDocumentTopicsResponse extends Message<ListDocumentTopicsResponse> {
  /**
   * @generated from field: repeated string communityTopics = 1;
   */
  communityTopics: string[] = [];

  /**
   * @generated from field: repeated string userTopics = 2;
   */
  userTopics: string[] = [];

  constructor(data?: PartialMessage<ListDocumentTopicsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDocumentTopicsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "communityTopics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "userTopics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDocumentTopicsResponse {
    return new ListDocumentTopicsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDocumentTopicsResponse {
    return new ListDocumentTopicsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDocumentTopicsResponse {
    return new ListDocumentTopicsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDocumentTopicsResponse | PlainMessage<ListDocumentTopicsResponse> | undefined, b: ListDocumentTopicsResponse | PlainMessage<ListDocumentTopicsResponse> | undefined): boolean {
    return proto3.util.equals(ListDocumentTopicsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListFormResultsRequest
 */
export class ListFormResultsRequest extends Message<ListFormResultsRequest> {
  /**
   * @generated from field: string documentUUID = 1;
   */
  documentUUID = "";

  constructor(data?: PartialMessage<ListFormResultsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFormResultsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentUUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFormResultsRequest {
    return new ListFormResultsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFormResultsRequest {
    return new ListFormResultsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFormResultsRequest {
    return new ListFormResultsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFormResultsRequest | PlainMessage<ListFormResultsRequest> | undefined, b: ListFormResultsRequest | PlainMessage<ListFormResultsRequest> | undefined): boolean {
    return proto3.util.equals(ListFormResultsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListFormResultsResponse
 */
export class ListFormResultsResponse extends Message<ListFormResultsResponse> {
  /**
   * @generated from field: repeated protogen.Document documents = 1;
   */
  documents: Document[] = [];

  constructor(data?: PartialMessage<ListFormResultsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFormResultsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: Document, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFormResultsResponse {
    return new ListFormResultsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFormResultsResponse {
    return new ListFormResultsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFormResultsResponse {
    return new ListFormResultsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFormResultsResponse | PlainMessage<ListFormResultsResponse> | undefined, b: ListFormResultsResponse | PlainMessage<ListFormResultsResponse> | undefined): boolean {
    return proto3.util.equals(ListFormResultsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetOrCreateDocumentFromSourceRequest
 */
export class GetOrCreateDocumentFromSourceRequest extends Message<GetOrCreateDocumentFromSourceRequest> {
  /**
   * @generated from field: string sourceDocumentUUID = 1;
   */
  sourceDocumentUUID = "";

  /**
   * @generated from field: bool forceCreate = 2;
   */
  forceCreate = false;

  constructor(data?: PartialMessage<GetOrCreateDocumentFromSourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetOrCreateDocumentFromSourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sourceDocumentUUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "forceCreate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrCreateDocumentFromSourceRequest {
    return new GetOrCreateDocumentFromSourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrCreateDocumentFromSourceRequest {
    return new GetOrCreateDocumentFromSourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrCreateDocumentFromSourceRequest {
    return new GetOrCreateDocumentFromSourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrCreateDocumentFromSourceRequest | PlainMessage<GetOrCreateDocumentFromSourceRequest> | undefined, b: GetOrCreateDocumentFromSourceRequest | PlainMessage<GetOrCreateDocumentFromSourceRequest> | undefined): boolean {
    return proto3.util.equals(GetOrCreateDocumentFromSourceRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetOrCreateDocumentFromSourceResponse
 */
export class GetOrCreateDocumentFromSourceResponse extends Message<GetOrCreateDocumentFromSourceResponse> {
  /**
   * @generated from field: protogen.Document document = 1;
   */
  document?: Document;

  /**
   * @generated from field: bool wasCreated = 2;
   */
  wasCreated = false;

  constructor(data?: PartialMessage<GetOrCreateDocumentFromSourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetOrCreateDocumentFromSourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
    { no: 2, name: "wasCreated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrCreateDocumentFromSourceResponse {
    return new GetOrCreateDocumentFromSourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrCreateDocumentFromSourceResponse {
    return new GetOrCreateDocumentFromSourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrCreateDocumentFromSourceResponse {
    return new GetOrCreateDocumentFromSourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrCreateDocumentFromSourceResponse | PlainMessage<GetOrCreateDocumentFromSourceResponse> | undefined, b: GetOrCreateDocumentFromSourceResponse | PlainMessage<GetOrCreateDocumentFromSourceResponse> | undefined): boolean {
    return proto3.util.equals(GetOrCreateDocumentFromSourceResponse, a, b);
  }
}

